import {Injectable} from '@angular/core';
import {ApiRouteConfig} from "../../../../config/api.route.config";
import {HttpClient} from "@angular/common/http";
import {InterventionTeamContactDto} from "./intervention-team-contact.dto";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {PaginationResponse} from '../../../common/model/pagination-response';
import {InterventionTeamContactsQuery} from './intervention-team-contacts.query';
import {InterventionTeamSummary} from '../../../buildings/model/Intervention-team-summary';

@Injectable()
export class InterventionTeamContactResource {
  private readonly endpoint = this.api.MAINTENANCE_CONTACTS;

  constructor(
    private readonly api: ApiRouteConfig,
    private readonly http: HttpClient,
  ) {
  }

  public invite(contact: InterventionTeamContactDto) {
    return this.http.post<undefined>(`${this.endpoint}/${contact.id}/InviteToJobs`, {});
  }

  public get(): Observable<PaginationResponse<InterventionTeamContactDto>> {
    return this.http.get<PaginationResponse<InterventionTeamContactDto>>(this.endpoint);
  }

  public search(query: InterventionTeamContactsQuery) {
    return this.http.post<PaginationResponse<InterventionTeamContactDto>>(`${this.endpoint}/search`, query);
  }

  public update(contact: InterventionTeamContactDto): Observable<InterventionTeamContactDto> {
    return this.http.put<undefined>(this.endpoint, contact).pipe(
      map(() => contact),
    );
  }

  public delete(contact: InterventionTeamContactDto): Observable<undefined> {
    return this.http.delete<undefined>(`${this.endpoint}/${contact.id}`);
  }

  public create(contactDto: InterventionTeamContactDto): Observable<InterventionTeamContactDto> {
    return this.http.post<string>(this.endpoint, contactDto).pipe(
      map(id => ({...contactDto, id})),
    )
  }
}
